import React, { useState } from "react";

interface TimeSlotGridProps {
  dates: Date[];
  timeSlots: number[];
  selectedTimeSlots: string[];
  selectedDate: string | null;
  selectedTime: number | null;
  duration: number;
  maxDuration: number;
  occupiedSlots: Record<string, number[]>;
  sunnySlots: Record<string, number[]>;
  onToggleTimeSlot: (date: string, time: number) => void;
}

export const TimeSlotGrid: React.FC<TimeSlotGridProps> = ({
  dates,
  timeSlots,
  selectedTimeSlots,
  selectedDate,
  selectedTime,
  duration,
  maxDuration,
  occupiedSlots,
  sunnySlots,
  onToggleTimeSlot,
}) => {
  const isSlotSelected = (date: string, time: number) => {
    if (selectedDate == date && selectedTime !== null) {
      if (time>=selectedTime && time<selectedTime+duration){
        return true;
      }
    }
    return false;
  };

  const [isHovering, setIsHovering] = useState<string>('');
  const handleMouseOver = (date: string, time: number) => {
    setIsHovering(date+'-'+time);
  };
  const handleMouseOut = () => {
    setIsHovering('');
  };

  const isSlotOccupied = (date: string, time: number) => {
    return occupiedSlots[date]?.includes(time);
  };

  const formatTime = (time: number) => {
    let ret = (time<10)?'0':'';
    ret += time+':00 - ';
    ret += (time+1<10)?'0':'';
    ret += (time+1)+':00';
    return ret;
  };

  const getSVG = (date: string, time: number) => {
    if (date in sunnySlots && sunnySlots[date].indexOf(time) != -1)
      return 'M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z';
    return '';
  };

  const isCellHovering = (date: string, time: number) => {
    if (selectedDate !== null && selectedTime !== null ) {
      const hoverTime = parseInt(isHovering.substring(11,13));
      if (selectedDate == date && selectedTime < time && hoverTime >= time && maxDuration >= (time - selectedTime)) {
        return true;
      }
    } else {
      if (date+'-'+time === isHovering)
        return true;
    }
    return false;
  };

  return (
    <div className="overflow-x-auto pb-5 mb-5 whitespace-nowrap" id="time-grid">
      <div className="inline-flex min-w-full">
        {dates.map((date) => (
          <div
            className="border-r border-solid border-r-neutral-200 min-w-[120px]"
            key={date.toLocaleDateString("en-CA")}
          >
            <div className="p-2.5 text-sm font-light text-center uppercase border-b border-solid border-b-neutral-200">
              {date.toLocaleDateString("ru-RU", {
                weekday: "short",
                day: "numeric",
                month: "short",
              })}
            </div>
            {timeSlots.map((time) => (
              <div
                className="flex justify-between items-center h-8 text-xs font-light border-b border-solid transition-all border-b-neutral-200 duration-[0.3s] ease-[ease]"
                key={`${date.toLocaleDateString("en-CA")}-${time}`}
                onClick={() => onToggleTimeSlot(date.toLocaleDateString("en-CA"), time)}
                onMouseOver={() => { handleMouseOver(date.toLocaleDateString("en-CA"), time) }} onMouseOut={handleMouseOut}
                style={{
                  cursor: isSlotOccupied(date.toLocaleDateString("en-CA"), time)
                    ? "not-allowed"
                    : "pointer",
                  color: isSlotSelected(date.toLocaleDateString("en-CA"), time) ? "#fff" : "#666",
                  backgroundColor: isSlotOccupied(date.toLocaleDateString("en-CA"), time)
                    ? "#f0f0f0"
                    : isSlotSelected(date.toLocaleDateString("en-CA"), time)
                      ? "rgb(255, 136, 0)"
                      : isCellHovering(date.toLocaleDateString("en-CA"), time)
                        ? "rgba(255, 136, 0, 0.2)"
                        : "transparent",
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="orange" className="size-5 pt-1">
                  <path/>
                </svg>
                <span>{formatTime(time)}</span>
                
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="orange" className="size-5 pt-1">
                  <path d={getSVG(date.toLocaleDateString("en-CA"), time)} />
                </svg>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
